export default __webpack_public_path__ + "static/media/peugeot.29ac1db4.svg";